import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import { useCatalogPermissionUserConfigListPresenter } from './useCatalogPermissionUserConfigListPresenter'
import { CatalogPermissionUserConfigTable } from '../../views/CatalogPermissionUserConfigTable'

export interface ICatalogPermissionUserConfigListPresenterProps {
  selectedUserId: Nullable<number>
  onSelectUser: (user: CatalogPermissionUserConfig) => void
}

export const CatalogPermissionUserConfigListPresenter = ({
  selectedUserId,
  onSelectUser,
}: ICatalogPermissionUserConfigListPresenterProps) => {
  const {
    data: { items, paging },
    states: { isLoading, isError, searchValue },
    commands: {
      handleSelectUser,
      handleSearchChange,
      handleSearchSubmit,
      handlePageChange,
    },
  } = useCatalogPermissionUserConfigListPresenter({
    selectedUserId,
    onSelectUser,
  })

  return (
    <CatalogPermissionUserConfigTable
      items={items}
      selectedUserId={selectedUserId}
      onSelectUser={handleSelectUser}
      isLoading={isLoading}
      isError={isError}
      searchValue={searchValue}
      onSearchChange={handleSearchChange}
      onSearchSubmit={handleSearchSubmit}
      paging={paging}
      onPageChange={handlePageChange}
    />
  )
}

CatalogPermissionUserConfigListPresenter.displayName =
  'CatalogPermissionUserConfigListPresenter'
